import { TypesView } from '@today/ui-domain'
import { useContentTypesAdmin } from '@/hooks/content/useContentTypesAdmin'

/** `/content/types` — content types (TO-420 content-admin-ui REQ-009). */
export function ContentTypesPage() {
	return <TypesView {...useContentTypesAdmin()} />
}
